import { apiInterfaceForJson } from '../common/apiManager';

export const fetchQcResults = () => {
    return apiInterfaceForJson('/qc_result/v1/', 'GET');
};

export const getQcResultDataById = (qcResultId) => {
    return apiInterfaceForJson('/qc_result/v1/' + qcResultId, 'GET');
};

export const searchQcResults = (filter) => {
    return apiInterfaceForJson('/qc_result/v1/search', 'POST', filter);
};

export const searchQcResultsForReport = (filter) => {
    return apiInterfaceForJson('/qc_result/v1/searchForReport', 'POST', filter);
};

export const createQcResult = (qcResultDetails) => {
    return apiInterfaceForJson('/qc_result/v1/', 'POST', qcResultDetails);
};

export const updateQcResult = (qcResultDetails) => {
    return apiInterfaceForJson('/qc_result/v1/', 'PUT', qcResultDetails);
};

export const deleteQcResult = (qcResultDetails) => {
    return apiInterfaceForJson('/qc_result/v1/delete', 'POST', qcResultDetails);
};

export const updateQcResultStatus = (qcResultDetails) => {
    return apiInterfaceForJson('/qc_result/v1/updateresultstatus', 'POST',qcResultDetails);
};